import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTileNoData = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Icons_UI_Error_Error_Inactive",
	"data-name": "Icons & UI/Error/Error_Inactive",
	xmlns: "http://www.w3.org/2000/svg",
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Icon",
		d: "M35.467,38H2.533A2.536,2.536,0,0,1,0,35.467a4.633,4.633,0,0,1,.735-2.141l.2-.394,15.536-31.1a2.664,2.664,0,0,1,5.065,0l15.536,31.1.2.394A4.634,4.634,0,0,1,38,35.467,2.536,2.536,0,0,1,35.467,38ZM19,27.155a2.153,2.153,0,1,0,2.153,2.153A2.155,2.155,0,0,0,19,27.155Zm0-15.47a2.155,2.155,0,0,0-2.153,2.153v8.615a2.153,2.153,0,1,0,4.305,0V13.838A2.155,2.155,0,0,0,19,11.685Z",
		transform: "translate(0 0)",
		fill: "#e8111c"
	})
});
export { SvgTileNoData as ReactComponent };
